import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { requestAccountUpgrade } from './requestAccountUpgrade.thunk';
import {
  confirmUpgradeToProfessionalPayment,
  issueProfessionalSubscription,
  upgradeToProfessionalAccount,
  IIssueProfessionalSubscriptionResponse
} from './upgradeToPro.thunk';

export interface UpgradeAccountState {
  requestedUpgrade: boolean;
  loading: boolean;
  error: string | null;
  issuingProUpgrade: boolean;
  confirmingProPayment: boolean;
  upgradingToPro: boolean;
  upgradeToProClientSecret: string | null;
}

const initialState: UpgradeAccountState = {
  requestedUpgrade: false,
  loading: false,
  error: null,
  issuingProUpgrade: false,
  confirmingProPayment: false,
  upgradingToPro: false,
  upgradeToProClientSecret: null
};

const extraReducers = {
  [requestAccountUpgrade.pending.type]: (state: UpgradeAccountState): void => {
    state.loading = true;
    state.error = null;
    state.requestedUpgrade = false;
  },
  [requestAccountUpgrade.rejected.type]: (state: UpgradeAccountState, action: PayloadAction<string>): void => {
    state.loading = false;
    state.error = action.payload;
    state.requestedUpgrade = false;
  },
  [requestAccountUpgrade.fulfilled.type]: (state: UpgradeAccountState): void => {
    state.loading = false;
    state.error = null;
    state.requestedUpgrade = true;
  },
  [confirmUpgradeToProfessionalPayment.pending.type]: (state: UpgradeAccountState): void => {
    state.confirmingProPayment = true;
    state.error = null;
  },
  [confirmUpgradeToProfessionalPayment.rejected.type]: (state: UpgradeAccountState, action: PayloadAction<string>): void => {
    state.confirmingProPayment = false;
    state.error = action.payload;
  },
  [confirmUpgradeToProfessionalPayment.fulfilled.type]: (state: UpgradeAccountState): void => {
    state.confirmingProPayment = false;
    state.error = null;
  },
  [issueProfessionalSubscription.pending.type]: (state: UpgradeAccountState): void => {
    state.issuingProUpgrade = true;
    state.error = null;
    state.upgradeToProClientSecret = null;
  },
  [issueProfessionalSubscription.rejected.type]: (state: UpgradeAccountState, action: PayloadAction<string>): void => {
    state.issuingProUpgrade = false;
    state.error = action.payload;
  },
  [issueProfessionalSubscription.fulfilled.type]: (state: UpgradeAccountState, action: PayloadAction<IIssueProfessionalSubscriptionResponse>): void => {
    state.issuingProUpgrade = false;
    state.error = null;
    state.upgradeToProClientSecret = action.payload.clientSecret;
  },
  [upgradeToProfessionalAccount.pending.type]: (state: UpgradeAccountState): void => {
    state.upgradingToPro = true;
    state.error = null;
  },
  [upgradeToProfessionalAccount.rejected.type]: (state: UpgradeAccountState, action: PayloadAction<string>): void => {
    state.upgradingToPro = false;
    state.error = action.payload;
  },
  [upgradeToProfessionalAccount.fulfilled.type]: (state: UpgradeAccountState): void => {
    state.upgradingToPro = false;
    state.error = null;
  }
};

const UpgradeAccountSlice = createSlice({
  name: 'UpgradeAccount',
  initialState,
  reducers: {},
  extraReducers
});

export const UpgradeAccountReducer = UpgradeAccountSlice.reducer;
